<template>
    <a-modal
        centered
        :title="`商标类别（已选${selected.length}个）`"
        :visible="visible"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="540"
        :after-close="after_close"
    >
        <a-checkable-tag
            v-for="(item, index) in trademark_array"
            :key="index"
            :checked="selected.some((v) => v.value == item.value)"
            class="r-checkbox checkbox-tag"
            :value="JSON.stringify(item)"
            @change="(e) => on_click(e, item)"
            ><strong>{{ item.value }}</strong> {{ item.name }}</a-checkable-tag
        >
    </a-modal>
</template>
<script>
    import basic_data from "../../mixins/basic_data";
    export default {
        mixins: [basic_data],
        props: {
            visible: false,
            callback: null,
            record: null,
        },
        data() {
            return {
                selected: [],
            };
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    this.selected = []
                    let selected_ids = this.record.toString().split(',');
                    selected_ids.forEach((id) => {
                        let select_trademark = this.trademark_array.find(x => x.value === id)
                        if(select_trademark != null) this.selected.push(select_trademark)
                    })
                }
            },
        },
        methods: {
            on_ok() {
                this.$emit("change", this.selected);
                this.on_cancel();
            },
            after_close() {
                this.selected = [];
            },
            on_cancel() {
                this.$emit("close");
            },
            on_click(a, b) {
                console.log(b);
                if (a) {
                    this.selected = [...this.selected, b];
                } else {
                    this.selected.splice(
                        this.selected.findIndex((v) => v.value == b.value),
                        1
                    );
                }
            },
        },
    };
</script>
<style lang="less" scoped>
    .r-checkbox {
        cursor: pointer;
        width: 90px;
    }
</style>
